module.exports = __webpack_public_path__ + "static/media/logo@3x.90cd0893.png";